import React, { Component } from 'react';
import { getIcon } from '../../../Common/Common';
import Advanced_Settings from './Components/Advanced_Settings';

export default class StatusOperation extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);
		let icon_width = 150;

		return (
			<div id='status_operation' >
				<div>
					<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width, }} />
				</div>
				<Advanced_Settings
					point_id={this.props.point_id}
					point_info={this.props.point_info}
					receiver={this.props.receiver}
					width={this.props.width}
					height={this.props.height}
					colours={this.props.colours}
				/>
			</div>
		)
	}
}